const propertyOwnershipMap: Record<string, string> = {
  OH4373: "Franchise - Sonesta",
  OH4372: "Franchise - Sonesta",
  KS2922: "Franchise - Sonesta",
  NY4244: "Franchise - Sonesta",
  MO1166: "Franchise - Sonesta",
  LA3438: "Franchise - ABVI",
  NC5086: "Franchise - Red Lion",
  CA9705: "Franchise - Sonesta",
  UT2780: "Franchise - ABVI",
  LA3470: "Franchise - Sonesta",
  AR3803: "Franchise - ABVI",
  TX10007: "Franchise - ABVI",
  IA2551: "Franchise - Sonesta",
  TX7926: "Franchise - Sonesta",
  TX6509: "Franchise - Sonesta",
  CA11026: "Franchise - Sonesta",
  AZ3369: "Franchise - Sonesta",
  NC5072: "Franchise - ABVI",
  IA2680: "Franchise - Red Lion",
  OK2744: "Franchise - ABVI",
  GA8309: "Franchise - Sonesta",
  TX9974: "Franchise - Sonesta",
  ON2309: "Franchise - ABVI",
  GA8247: "Franchise - Sonesta",
  IL1171: "Franchise - ABVI",
  TX5039: "Franchise - Sonesta",
  TX6905: "Franchise - ABVI",
  TX7411: "Franchise - Red Lion",
  KS2920: "Franchise - Sonesta",
  TX5119: "Franchise - ABVI",
  NC5720: "Franchise - Sonesta",
  WV2151: "Franchise - ABVI",
  SD2579: "Franchise - Sonesta",
  WA2595: "Franchise - ABVI",
  KS2860: "Franchise - ABVI",
  TX9967: "Franchise - Sonesta",
  LA3403: "Franchise - ABVI",
  TX5940: "Franchise - ABVI",
  IL5435: "Franchise - ABVI",
  IL6305: "Franchise - Sonesta",
  AL5409: "Franchise - ABVI",
  SC7995: "Franchise - ABVI",
  CA12093: "Franchise - Sonesta",
  MD3635: "Franchise - Sonesta",
  IL6303: "Franchise - ABVI",
  MX1012: "Costa Sur",
  TX6245: "Franchise - Sonesta",
  NJ3136: "Franchise - Sonesta",
  AR3325: "Franchise - Sonesta",
  MD3636: "Franchise - ABVI",
  TX8708: "Franchise - Sonesta",
  WV2149: "Franchise - Sonesta",
  MI4383: "Franchise - Sonesta",
  IA2523: "Franchise - Sonesta",
  NC5401: "Franchise - ABVI",
  IL5080: "Franchise - Red Lion",
  GA7325: "Franchise - Sonesta",
  NV2816: "Franchise - Sonesta",
  FL10416: "Franchise - Sonesta",
  KS2451: "Franchise - Red Lion",
  AL5345: "Franchise - ABVI",
  WV2150: "Franchise - Sonesta",
  WY2063: "Franchise - Red Lion",
  IL5479: "Franchise - ABVI",
  TX6945: "Franchise - ABVI",
  TX8069: "Franchise - Sonesta",
  FL8050: "Franchise - ABVI",
  TX5867: "Franchise - Sonesta",
  KY5421: "Franchise - ABVI",
  AR3794: "Franchise - ABVI",
  NC5065: "Franchise - ABVI",
  OH4369: "Franchise - Red Lion",
  NE2585: "Franchise - ABVI",
  PA2944: "Franchise - ABVI",
  IL5235: "Franchise - Red Lion",
  IL6019: "Franchise - Red Lion",
  TX5041: "Franchise - Sonesta",
  IL5613: "Franchise - Sonesta",
  LA3440: "Franchise - Sonesta",
  TX6473: "Franchise - Sonesta",
  TN4366: "Franchise - Sonesta",
  CA8146: "Franchise - Sonesta",
  TX6841: "Franchise - Sonesta",
  MN3219: "Franchise - ABVI",
  IN5752: "Franchise - Sonesta",
  TX7674: "Franchise - ABVI",
  ME2212: "Franchise - ABVI",
  TX5567: "Franchise - ABVI",
  ND2281: "Franchise - Sonesta",
  CA12055: "Franchise - Sonesta",
  LA3235: "Franchise - ABVI",
  NE2270: "Franchise - Red Lion",
  FL10405: "Franchise - Sonesta",
  AB1585: "Franchise - Sonesta",
  PA2999: "Franchise - ABVI",
  TX5638: "Franchise - Sonesta",
  CO3423: "Franchise - Red Lion",
  MD3492: "Franchise - ABVI",
  NV2590: "Franchise - Red Lion",
  NY2255: "Franchise - ABVI",
  NV2744: "Franchise - Red Lion",
  FL7938: "Franchise - Sonesta",
  KY5755: "Franchise - ABVI",
  VAC002: "GHL",
  GA7051: "Franchise - ABVI",
  ID2558: "Franchise - ABVI",
  GA7196: "Franchise - ABVI",
  KS2340: "Franchise - Sonesta",
  KY5095: "Franchise - ABVI",
  WA2515: "Franchise - Red Lion",
  MT2179: "Franchise - ABVI",
  FL7889: "SVC",
  CA8581: "SVC",
  NE2352: "Franchise - Sonesta",
  OH3424: "Franchise - Sonesta",
  MI3491: "SVC",
  TX6351: "Franchise - Sonesta",
  TX6449: "Franchise - Sonesta",
  AZ2808: "SVC",
  CA8980: "SVC",
  AL5412: "SVC",
  MI3543: "SVC",
  MI3544: "SVC",
  AZ2815: "SVC",
  IA2615: "SVC",
  NM2464: "SVC",
  TX6518: "SVC",
  IL5598: "SVC",
  NC5614: "SVC",
  TX6546: "SVC",
  CA9037: "SVC",
  MA2203: "SVC",
  MN2725: "Franchise - Sonesta",
  TX6595: "SVC",
  TX6596: "Franchise - Sonesta",
  VA5541: "SVC",
  TX6705: "Franchise - Sonesta",
  AZ2869: "SVC",
  NV2532: "SVC",
  NJ3416: "SVC",
  MA2219: "SVC",
  NY2903: "Franchise - Sonesta",
  NJ3436: "SVC",
  CA9512: "SVC",
  CA9898: "Franchise - Sonesta",
  TN4258: "Franchise - Sonesta",
  OH4179: "SVC",
  GA8715: "Franchise - Sonesta",
  LA3939: "Sonesta - Owned",
  AZ3229: "SVC",
  BC1698: "Franchise - ABVI",
  KS2913: "Franchise - ABVI",
  NJ3091: "Franchise - Sonesta",
  NJ3159: "Franchise - Sonesta",
  DE2321: "SVC",
  TN3150: "Franchise - ABVI",
  ID2256: "Franchise - ABVI",
  UT2266: "Franchise - ABVI",
  ND2115: "Franchise - ABVI",
  TX5742: "Franchise - ABVI",
  MI3284: "Franchise - Sonesta",
  AZ2645: "SVC",
  CO2662: "Franchise - Sonesta",
  MO3359: "SVC",
  UT2367: "SVC",
  NV2466: "Franchise - ABVI",
  FL8312: "SVC",
  VA5492: "SVC",
  MI3530: "Franchise - Sonesta",
  TN3715: "Franchise - Sonesta",
  PA2677: "SVC",
  TX6499: "Franchise - Sonesta",
  TX6517: "SVC",
  MD3258: "SVC",
  TX6555: "SVC",
  CA9042: "SVC",
  GA7759: "SVC",
  FL8439: "SVC",
  IL5608: "SVC",
  TN3744: "SVC",
  TX6567: "SVC",
  CO2847: "SVC",
  IL5626: "SVC",
  OH3630: "SVC",
  OH3631: "SVC",
  FL8492: "SVC",
  IL5640: "SVC",
  IL5653: "SVC",
  GA7842: "SVC",
  MA2224: "SVC",
  MI3635: "Franchise - Sonesta",
  WA2800: "SVC",
  CA9446: "SVC",
  IL6046: "Franchise - Sonesta",
  VT1410: "Franchise - Sonesta",
  OH4159: "Franchise - Sonesta",
  NJ3924: "SVC",
  MO4023: "Franchise - Sonesta",
  RI1260: "Franchise - Sonesta",
  OH4244: "Franchise - Sonesta",
  AL5833: "Franchise - Sonesta",
  FL10175: "SVC",
  GA8796: "Franchise - Sonesta",
  CO2379: "Franchise - ABVI",
  CA7275: "Franchise - Sonesta",
  OR2378: "Franchise - Sonesta",
  OR2382: "Franchise - Red Lion",
  TX5419: "Franchise - ABVI",
  OK2385: "Franchise - ABVI",
  CA7226: "Franchise - ABVI",
  AL5057: "Franchise - ABVI",
  GA7144: "Franchise - ABVI",
  TX5373: "Franchise - ABVI",
  NJ3074: "Franchise - ABVI",
  MS2348: "Franchise - ABVI",
  TX5390: "Franchise - Red Lion",
  IA2347: "Franchise - ABVI",
  WI3051: "Franchise - ABVI",
  WA3257: "Franchise - ABVI",
  NY4231: "Sonesta - Owned",
  NY4232: "Sonesta - Owned",
  NY4233: "Sonesta - Owned",
  NY4234: "Sonesta - Owned",
  MA2602: "SVC",
  IL6279: "SVC",
  MD3619: "SVC",
  TX9868: "SVC",
  HI1162: "SVC",
  LA3949: "SVC",
  OR3224: "SVC",
  PR6201: "SVC",
  DC5076: "SVC",
  GA8884: "SVC",
  GA8885: "SVC",
  TX9869: "Sonesta - Owned",
  NC6607: "SVC",
  OH4349: "SVC",
  CO3416: "SVC",
  CA11987: "SVC",
  NM2859: "SVC",
  PA3546: "Franchise - Sonesta",
  GA8886: "SVC",
  CA11988: "SVC",
  MD3620: "SVC",
  GA8887: "SVC",
  GA8888: "SVC",
  GA8889: "SVC",
  GA8890: "SVC",
  TX9870: "SVC",
  MD3621: "SVC",
  LA3950: "SVC",
  AL5891: "SVC",
  CA11989: "SVC",
  WV2147: "SVC",
  VA6284: "SVC",
  CA11990: "SVC",
  IL6280: "SVC",
  IL6281: "Franchise - Sonesta",
  TX9871: "Franchise - Sonesta",
  TX9872: "Franchise - Sonesta",
  TX9873: "Franchise - Sonesta",
  TX9874: "Franchise - Sonesta",
  CO3417: "SVC",
  MI4368: "SVC",
  VA6285: "SVC",
  VA6286: "SVC",
  FL10377: "SVC",
  TX9875: "Franchise - Sonesta",
  CA11991: "SVC",
  GA8891: "Franchise - Sonesta",
  CA11992: "SVC",
  FL10378: "SVC",
  TN4453: "SVC",
  LA3951: "SVC",
  NJ3994: "SVC",
  WA3261: "SVC",
  NJ3995: "SVC",
  NC6608: "SVC",
  NC6609: "SVC",
  NV2806: "SVC",
  TX9876: "SVC",
  TX9877: "Franchise - Sonesta",
  CA11993: "SVC",
  CA11994: "SVC",
  CA11995: "SVC",
  CA11996: "SVC",
  CA11997: "SVC",
  AZ3326: "SVC",
  CA11998: "SVC",
  AZ3327: "SVC",
  ON2303: "SVC",
  CA11999: "SVC",
  FL10379: "SVC",
  CA12000: "SVC",
  CA12001: "SVC",
  FL10380: "SVC",
  WI4110: "Franchise - Sonesta",
  TN4454: "SVC",
  PA3547: "SVC",
  CA12002: "SVC",
  SC8067: "SVC",
  CA12003: "SVC",
  PA3548: "Franchise - Sonesta",
  VA6287: "SVC",
  GA8892: "SVC",
  GA8893: "SVC",
  GA8894: "Franchise - Sonesta",
  GA8895: "SVC",
  GA8896: "Franchise - Sonesta",
  TX9878: "Franchise - Sonesta",
  FL10381: "SVC",
  MA2604: "SVC",
  MA2605: "SVC",
  MA2606: "SVC",
  MA2607: "SVC",
  CA12004: "SVC",
  NC6610: "SVC",
  TN4455: "SVC",
  MD3622: "SVC",
  TX9879: "Franchise - Sonesta",
  TX9880: "Franchise - Sonesta",
  MI4369: "Franchise - Sonesta",
  MI4370: "Franchise - Sonesta",
  NC6611: "Franchise - Sonesta",
  MD3623: "Franchise - Sonesta",
  CA12005: "SVC",
  IN5954: "SVC",
  MO4127: "Franchise - Sonesta",
  MO4128: "SVC",
  CA12006: "SVC",
  NV2807: "SVC",
  CA12007: "SVC",
  CA12008: "SVC",
  FL10382: "SVC",
  WI4111: "Franchise - Sonesta",
  MN3214: "Franchise - Sonesta",
  TN4456: "SVC",
  DE2390: "Franchise - Sonesta",
  RI1275: "SVC",
  PA3549: "SVC",
  AZ3328: "SVC",
  AZ3329: "SVC",
  CA12009: "SVC",
  NC6612: "SVC",
  CA12010: "SVC",
  CA12011: "SVC",
  CA12012: "SVC",
  AZ3330: "SVC",
  WA3262: "SVC",
  AZ3331: "SVC",
  NJ3998: "SVC",
  NJ3999: "SVC",
  OK3212: "SVC",
  AZ3333: "SVC",
  WA3263: "SVC",
  NY4225: "SVC",
  WA3264: "SVC",
  MO4129: "SVC",
  CA12013: "SVC",
  TX9883: "SVC",
  ON2304: "SVC",
  GA8879: "Franchise - ABVI",
  CHL001: "GHL",
  CUN001: "GHL",
  CES001: "GHL",
  RIS001: "GHL",
  TOL001: "GHL",
  SAN001: "GHL",
  BOL001: "GHL",
  ECU002: "GHL",
  EGY001: "Egypt - Hotels",
  EGY002: "Egypt - Hotels",
  PER001: "GHL - Posadas",
  PER002: "GHL",
  PER003: "GHL",
  PER004: "GHL - Posadas",
  PER005: "GHL",
  SXM001: "St. Maarten",
  SXM002: "St. Maarten",
  DC5080: "SVC",
  MN3218: "SVC",
  EGY007: "Egypt - Hotels",
  EGY008: "Egypt - Cruises",
  EGY009: "Egypt - Cruises",
  EGY010: "Egypt - Cruises",
  EGY011: "Egypt - Cruises",
  EGY012: "Egypt - Cruises",
  BC1699: "Franchise - ABVI",
  EGY013: "Egypt - Cruises",
  CAAUBU: "Franchise - Red Lion",
  CA7087: "Franchise - ABVI",
  CAMIL: "SVC",
  CAREDD: "Franchise - Red Lion",
  CAREKA: "Franchise - Red Lion",
  IDBOIS: "Franchise - Red Lion",
  IDPOCA: "Franchise - Red Lion",
  IDTEMP: "Franchise - Red Lion",
  MTKALS: "Sonesta - Owned",
  MTMISS: "Franchise - Red Lion",
  MTPOLS: "Franchise - Red Lion",
  NVELKO: "Franchise - Red Lion",
  ORAIRP: "Franchise - Red Lion",
  ORCOOS: "Franchise - Red Lion",
  ORGPAS: "Franchise - Red Lion",
  ORMCMN: "Franchise - Red Lion",
  ORONIS: "Franchise - Red Lion",
  ORPEND: "Franchise - Red Lion",
  PAHARR: "Franchise - Red Lion",
  UTSTGE: "Franchise - Red Lion",
  WAANGE: "Franchise - Red Lion",
  WABELL: "Franchise - Red Lion",
  WAELLE: "Franchise - Red Lion",
  WAEVIS: "Franchise - Red Lion",
  WAKELS: "Franchise - Red Lion",
  WAKENN: "Franchise - Red Lion",
  WAPSCO: "Franchise - Red Lion",
  WASQIS: "Franchise - Red Lion",
  WAVNSC: "Franchise - Red Lion",
  WAWENA: "Franchise - Red Lion",
  WAYAKI: "Franchise - Red Lion",
  IL5024: "SVC",
  IL5030: "SVC",
  SC7011: "Franchise - ABVI",
  FL7067: "Franchise - ABVI",
  TX5069: "Franchise - ABVI",
  TX0342: "Franchise - ABVI",
  CA0345: "Franchise - ABVI",
  TX0351: "Franchise - ABVI",
  MT0423: "Franchise - ABVI",
  CA0425: "Franchise - ABVI",
  IA0433: "Franchise - ABVI",
  NE0454: "Franchise - ABVI",
  CA0468: "Franchise - ABVI",
  RI0477: "Franchise - ABVI",
  IL0484: "Franchise - ABVI",
  BC0486: "Franchise - ABVI",
  TN0490: "Franchise - ABVI",
  MD0498: "Franchise - ABVI",
  TX0511: "Franchise - ABVI",
  OR0512: "Franchise - ABVI",
  NV0548: "Franchise - ABVI",
  MI0550: "Franchise - ABVI",
  TX0555: "Franchise - ABVI",
  AR0559: "Franchise - ABVI",
  WY0560: "Franchise - ABVI",
  MA0579: "Franchise - ABVI",
  OR0585: "Franchise - ABVI",
  CA0586: "Franchise - ABVI",
  TX0601: "Franchise - ABVI",
  CA0617: "Franchise - ABVI",
  KY0624: "Franchise - ABVI",
  CA0638: "Franchise - ABVI",
  TN0654: "Franchise - ABVI",
  AZ0660: "Franchise - ABVI",
  AL0663: "Franchise - ABVI",
  CA0664: "Franchise - ABVI",
  NC0675: "Franchise - ABVI",
  TN0683: "Franchise - ABVI",
  AL0685: "Franchise - ABVI",
  OH0698: "Franchise - ABVI",
  AR0714: "Franchise - ABVI",
  CA0725: "Franchise - ABVI",
  OH0728: "Franchise - ABVI",
  TX0731: "Franchise - ABVI",
  AK0732: "Franchise - ABVI",
  SC0734: "Franchise - ABVI",
  TX0739: "Franchise - ABVI",
  TX0743: "Franchise - ABVI",
  WY0746: "Franchise - ABVI",
  MO0748: "Franchise - ABVI",
  ME0769: "Franchise - ABVI",
  CA0777: "Franchise - ABVI",
  TX0785: "Franchise - ABVI",
  KS0804: "Franchise - ABVI",
  PA0812: "Franchise - ABVI",
  NE0814: "Franchise - ABVI",
  OR0853: "Franchise - ABVI",
  TX0866: "Franchise - ABVI",
  TX0871: "Franchise - ABVI",
  OH0878: "Franchise - ABVI",
  AR0886: "Franchise - ABVI",
  TX0888: "Franchise - ABVI",
  TN0889: "Franchise - ABVI",
  TX0912: "Franchise - ABVI",
  TX0936: "Franchise - ABVI",
  CA0961: "Franchise - ABVI",
  AZ0967: "Franchise - ABVI",
  MS0972: "Franchise - ABVI",
  GA0973: "Franchise - ABVI",
  SC0974: "Franchise - ABVI",
  NC0985: "Franchise - ABVI",
  MS0995: "Franchise - ABVI",
  VA1004: "Franchise - ABVI",
  TX1005: "Franchise - ABVI",
  GA1010: "Franchise - ABVI",
  OR1014: "Franchise - ABVI",
  TX1018: "Franchise - ABVI",
  KS1026: "Franchise - ABVI",
  IL1032: "Franchise - ABVI",
  CA1037: "Franchise - ABVI",
  TX1043: "Franchise - ABVI",
  TN1046: "Franchise - ABVI",
  GA1049: "Franchise - ABVI",
  CO1055: "Franchise - ABVI",
  MS1076: "Franchise - ABVI",
  NC1079: "Franchise - ABVI",
  CA1091: "Franchise - ABVI",
  TN1128: "Franchise - ABVI",
  GA1130: "Franchise - ABVI",
  SD1132: "Franchise - ABVI",
  SC1133: "Franchise - ABVI",
  OH1135: "Franchise - ABVI",
  NY1146: "Franchise - ABVI",
  MI1177: "Franchise - ABVI",
  TX1183: "Franchise - ABVI",
  NY1185: "Franchise - ABVI",
  SC1188: "Franchise - ABVI",
  TN1192: "Franchise - ABVI",
  PA1194: "Franchise - ABVI",
  PA1195: "Franchise - ABVI",
  TX1212: "Franchise - ABVI",
  TX1218: "Franchise - ABVI",
  ME1222: "Franchise - ABVI",
  AR1231: "Franchise - ABVI",
  OK1237: "Franchise - ABVI",
  ON1243: "Franchise - ABVI",
  GA1245: "Franchise - ABVI",
  TX1255: "Franchise - ABVI",
  CA1260: "Franchise - ABVI",
  NC1276: "Franchise - ABVI",
  OR1278: "Franchise - ABVI",
  MO1280: "Franchise - ABVI",
  YT1285: "Franchise - ABVI",
  AR1287: "Franchise - ABVI",
  CA1289: "Franchise - ABVI",
  CA1299: "Franchise - ABVI",
  SD1311: "Franchise - ABVI",
  TX1329: "Franchise - ABVI",
  MS1330: "Franchise - ABVI",
  CA1341: "Franchise - ABVI",
  NY1353: "Franchise - ABVI",
  MN1356: "Franchise - ABVI",
  NY1358: "Franchise - ABVI",
  CA1365: "Franchise - ABVI",
  NY1366: "Franchise - ABVI",
  AR1373: "Franchise - ABVI",
  TX1378: "Franchise - ABVI",
  MA1381: "Franchise - ABVI",
  TX1384: "Franchise - ABVI",
  CA1393: "Franchise - ABVI",
  IL1407: "Franchise - ABVI",
  CA1408: "Franchise - ABVI",
  MI1411: "Franchise - ABVI",
  LA1412: "Franchise - ABVI",
  CA1420: "Franchise - ABVI",
  TX1424: "Franchise - ABVI",
  AR1426: "Franchise - ABVI",
  TX1427: "Franchise - ABVI",
  TX1433: "Franchise - ABVI",
  CA1437: "Franchise - ABVI",
  CA1439: "Franchise - ABVI",
  MI1441: "Franchise - ABVI",
  TX1444: "Franchise - ABVI",
  GA1450: "Franchise - ABVI",
  CA1465: "Franchise - ABVI",
  OK1469: "Franchise - ABVI",
  TX1470: "Franchise - ABVI",
  AL1473: "Franchise - ABVI",
  TX1485: "Franchise - ABVI",
  MO1490: "Franchise - ABVI",
  TX1498: "Franchise - ABVI",
  TX1504: "Franchise - ABVI",
  NE1505: "Franchise - ABVI",
  GA1516: "Franchise - ABVI",
  KS1517: "Franchise - ABVI",
  MO1525: "Franchise - ABVI",
  MS1528: "Franchise - ABVI",
  FL1530: "Franchise - ABVI",
  OH1537: "Franchise - ABVI",
  TX1548: "Franchise - ABVI",
  TX1554: "Franchise - ABVI",
  MS1555: "Franchise - ABVI",
  BC1556: "Franchise - ABVI",
  AR1561: "Franchise - ABVI",
  MI1562: "Franchise - ABVI",
  MT1570: "Franchise - ABVI",
  TX1575: "Franchise - ABVI",
  CA1579: "Franchise - ABVI",
  OH1607: "Franchise - ABVI",
  TX1611: "Franchise - ABVI",
  MI1613: "Franchise - ABVI",
  CA1625: "Franchise - ABVI",
  TX1633: "Franchise - ABVI",
  TN1634: "Franchise - ABVI",
  GA1635: "Franchise - ABVI",
  TX1638: "Franchise - ABVI",
  CA1644: "Franchise - ABVI",
  MD1647: "Franchise - ABVI",
  BC1651: "Franchise - ABVI",
  TN1658: "Franchise - ABVI",
  MO1670: "Franchise - ABVI",
  MO1671: "Franchise - ABVI",
  MI1676: "Franchise - ABVI",
  PE1684: "Franchise - ABVI",
  PE1685: "Franchise - ABVI",
  OK1687: "Franchise - ABVI",
  TX1688: "Franchise - ABVI",
  TX1694: "Franchise - ABVI",
  MN1708: "Franchise - ABVI",
  UT1710: "Franchise - ABVI",
  MI1714: "Franchise - ABVI",
  NV1720: "Franchise - ABVI",
  CA1725: "Franchise - ABVI",
  FL1740: "Franchise - ABVI",
  OK1751: "Franchise - ABVI",
  OH1757: "Franchise - ABVI",
  NC1759: "Franchise - ABVI",
  UT1764: "Franchise - ABVI",
  MO1765: "Franchise - ABVI",
  LA1766: "Franchise - ABVI",
  MO1767: "Franchise - ABVI",
  WI1772: "Franchise - ABVI",
  CA1773: "Franchise - ABVI",
  MN1777: "Franchise - ABVI",
  MS1780: "Franchise - ABVI",
  CA1787: "Franchise - ABVI",
  NC1790: "Franchise - ABVI",
  MO1794: "Franchise - ABVI",
  MI1797: "Franchise - ABVI",
  FL1799: "Franchise - ABVI",
  FL1800: "Franchise - ABVI",
  NC1801: "Franchise - ABVI",
  GA1804: "Franchise - ABVI",
  MN1811: "Franchise - ABVI",
  IN1823: "Franchise - ABVI",
  KY1834: "Franchise - ABVI",
  CA1849: "Franchise - ABVI",
  TX1850: "Franchise - ABVI",
  TX1859: "Franchise - ABVI",
  FL1862: "Franchise - ABVI",
  NY1864: "Franchise - ABVI",
  TX1866: "Franchise - ABVI",
  OH1873: "Franchise - ABVI",
  PA1875: "Franchise - ABVI",
  MO1876: "Franchise - ABVI",
  OK1880: "Franchise - ABVI",
  GA1881: "Franchise - ABVI",
  FL1884: "Franchise - ABVI",
  GA1886: "Franchise - ABVI",
  NE1902: "Franchise - ABVI",
  TX1907: "Franchise - ABVI",
  LA1910: "Franchise - ABVI",
  MO1911: "Franchise - ABVI",
  LA1917: "Franchise - ABVI",
  TX1924: "Franchise - ABVI",
  AR1927: "Franchise - ABVI",
  MI1929: "Franchise - ABVI",
  MO1932: "Franchise - ABVI",
  NJ1935: "Franchise - ABVI",
  MI1936: "Franchise - ABVI",
  GA1948: "Franchise - ABVI",
  AR1950: "Franchise - ABVI",
  NM1958: "Franchise - ABVI",
  OK1959: "Franchise - ABVI",
  TX1963: "Franchise - ABVI",
  MO1964: "Franchise - ABVI",
  VA1966: "Franchise - ABVI",
  MS1972: "Franchise - ABVI",
  CA1973: "Franchise - ABVI",
  MI1976: "Franchise - ABVI",
  MN1985: "Franchise - ABVI",
  TN1987: "Franchise - ABVI",
  MI1996: "Franchise - ABVI",
  IL1998: "Franchise - ABVI",
  LA2002: "Franchise - ABVI",
  MI2005: "Franchise - ABVI",
  WA2006: "Franchise - ABVI",
  OK2008: "Franchise - ABVI",
  NY2011: "Franchise - ABVI",
  MO2012: "Franchise - ABVI",
  TX2013: "Franchise - ABVI",
  VA2015: "Franchise - ABVI",
  IL2016: "Franchise - ABVI",
  ND2028: "Franchise - ABVI",
  TX2034: "Franchise - ABVI",
  TX2050: "Franchise - ABVI",
  KS2051: "Franchise - ABVI",
  FL2052: "Franchise - ABVI",
  IL2054: "Franchise - ABVI",
  MS2057: "Franchise - ABVI",
  FL2059: "Franchise - ABVI",
  IL2062: "Franchise - ABVI",
  OK2068: "Franchise - ABVI",
  MS2069: "Franchise - ABVI",
  SC2073: "Franchise - ABVI",
  NC2080: "Franchise - ABVI",
  NE2099: "Franchise - ABVI",
  TX2100: "Franchise - ABVI",
  TX2101: "Franchise - ABVI",
  CA2102: "Franchise - ABVI",
  TX2105: "Franchise - ABVI",
  GA2114: "Franchise - ABVI",
  TX2122: "Franchise - ABVI",
  OK2126: "Franchise - ABVI",
  GA2129: "Franchise - ABVI",
  OH2133: "Franchise - ABVI",
  CT2134: "Franchise - ABVI",
  CA2135: "Franchise - ABVI",
  CA2136: "Franchise - ABVI",
  FL2138: "Franchise - ABVI",
  TX2141: "Franchise - ABVI",
  CA2142: "Franchise - ABVI",
  NC2143: "Franchise - ABVI",
  MS2152: "Franchise - ABVI",
  TX2155: "Franchise - ABVI",
  CO2159: "Franchise - ABVI",
  IL2162: "Franchise - ABVI",
  NY2166: "Franchise - ABVI",
  LA2167: "Franchise - ABVI",
  MS2169: "Franchise - ABVI",
  IA2170: "Franchise - ABVI",
  AR2171: "Franchise - ABVI",
  TX2173: "Franchise - ABVI",
  GA2181: "Franchise - ABVI",
  TX2182: "Franchise - ABVI",
  CA2183: "Franchise - ABVI",
  NC2185: "Franchise - ABVI",
  UT2190: "Franchise - ABVI",
  MO2195: "Franchise - ABVI",
  MN2202: "Franchise - ABVI",
  MS2204: "Franchise - ABVI",
  IL2209: "Franchise - ABVI",
  MS2212: "Franchise - ABVI",
  OR2216: "Franchise - ABVI",
  LA2217: "Franchise - ABVI",
  AL2221: "Franchise - ABVI",
  TX2224: "Franchise - ABVI",
  ID2226: "Franchise - ABVI",
  IL2229: "Franchise - ABVI",
  MS2239: "Franchise - ABVI",
  GA2240: "Franchise - ABVI",
  IN2244: "Franchise - ABVI",
  OR2248: "Franchise - ABVI",
  LA2252: "Franchise - ABVI",
  TX2257: "Franchise - ABVI",
  GA2261: "Franchise - ABVI",
  WA2263: "Franchise - ABVI",
  GA2264: "Franchise - ABVI",
  LA2266: "Franchise - ABVI",
  TX2268: "Franchise - ABVI",
  AZ2271: "Franchise - ABVI",
  MS2274: "Franchise - ABVI",
  CA2275: "Franchise - ABVI",
  TN2279: "Franchise - ABVI",
  IA2280: "Franchise - ABVI",
  IA2282: "Franchise - ABVI",
  TX2284: "Franchise - ABVI",
  TX2287: "Franchise - ABVI",
  TX2288: "Franchise - ABVI",
  CA2289: "Franchise - ABVI",
  TX2290: "Franchise - ABVI",
  TX2294: "Franchise - ABVI",
  MS2295: "Franchise - ABVI",
  TX2297: "Franchise - ABVI",
  TX2301: "Franchise - ABVI",
  CA2302: "Franchise - ABVI",
  TX2305: "Franchise - ABVI",
  TX2306: "Franchise - ABVI",
  OK2318: "Franchise - ABVI",
  MS2323: "Franchise - ABVI",
  TX2324: "Franchise - ABVI",
  TX2325: "Franchise - ABVI",
  TX2326: "Franchise - ABVI",
  MN2327: "Franchise - ABVI",
  BC0002: "Franchise - ABVI",
  ON0013: "Franchise - ABVI",
  AB0018: "Franchise - ABVI",
  BC0020: "Franchise - ABVI",
  BC0024: "Franchise - ABVI",
  BC0025: "Franchise - ABVI",
  AB0026: "Franchise - ABVI",
  BC0028: "Franchise - ABVI",
  FL1084: "Franchise - ABVI",
  MI1086: "Franchise - ABVI",
  GA3016: "Franchise - ABVI",
  OH3038: "Franchise - ABVI",
  GA3048: "Franchise - ABVI",
  TN3054: "Franchise - ABVI",
  GA3060: "Franchise - ABVI",
  GA3064: "Franchise - ABVI",
  GA5005: "Franchise - ABVI",
  CA0481: "Franchise - ABVI",
  TX0627: "Franchise - ABVI",
  NY0713: "Franchise - ABVI",
  CA0899: "Franchise - ABVI",
  CA1125: "Franchise - ABVI",
  MI1400: "Franchise - ABVI",
  CA1440: "Franchise - ABVI",
  TX1672: "Franchise - ABVI",
  LA1895: "Franchise - ABVI",
  FL1915: "Franchise - ABVI",
  CT1918: "Franchise - ABVI",
  AZ2001: "Franchise - ABVI",
  TX2041: "Franchise - ABVI",
  MO2104: "Franchise - ABVI",
  CA2107: "Franchise - ABVI",
  MS2227: "Franchise - ABVI",
  GA2296: "Franchise - ABVI",
  MO2313: "Franchise - ABVI",
  AZ2084: "Franchise - ABVI",
  ON0010: "Franchise - ABVI",
  LA3062: "Franchise - ABVI",
  WY2034: "Franchise - ABVI",
  MT2090: "Franchise - ABVI",
  NE2251: "Franchise - ABVI",
  TX5344: "Franchise - ABVI",
  GA7124: "Franchise - ABVI",
  AZ2342: "Franchise - ABVI",
  CA7069: "Franchise - ABVI",
  GA7033: "Franchise - ABVI",
  TX5088: "Franchise - ABVI",
  TX5089: "Franchise - ABVI",
  OR2309: "Franchise - ABVI",
  NC5035: "Franchise - ABVI",
  TX5115: "Franchise - ABVI",
  TX5137: "Franchise - ABVI",
  IL5040: "Franchise - ABVI",
  LA3073: "Franchise - ABVI",
  TX5145: "Franchise - ABVI",
  ID2233: "Franchise - ABVI",
  KS2295: "Franchise - ABVI",
  TX5262: "Franchise - ABVI",
  CA7182: "Franchise - ABVI",
  TX5326: "Franchise - ABVI",
  CT2286: "Franchise - ABVI",
  SD2174: "Franchise - ABVI",
  AR3098: "Franchise - ABVI",
  FL7210: "Franchise - ABVI",
  SC7042: "Franchise - ABVI",
  GA7123: "Franchise - ABVI",
  TN3080: "Franchise - ABVI",
  OR2322: "Franchise - ABVI",
  WA2328: "Franchise - Red Lion",
  NC5067: "Franchise - ABVI",
  AR3097: "Franchise - ABVI",
  MT2096: "Franchise - Red Lion",
  VA5081: "Franchise - ABVI",
  WA2356: "Franchise - ABVI",
  IA2340: "Franchise - ABVI",
  TX5095: "Franchise - ABVI",
  CA7096: "Franchise - Sonesta",
  CA7112: "Franchise - Red Lion",
  FL7105: "Franchise - ABVI",
  FL7162: "Franchise - ABVI",
  TX5309: "Franchise - Sonesta",
  VA5082: "Franchise - ABVI",
  NY2287: "Franchise - ABVI",
  FL7212: "Franchise - ABVI",
  MO3127: "Franchise - ABVI",
  FL7226: "Franchise - Red Lion",
  CA7209: "Franchise - Sonesta",
  WA2358: "Franchise - Red Lion",
  FLLBVS: "Franchise - Red Lion",
};

export default propertyOwnershipMap;
